var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.odata),function(item,index){return _c('li',{key:("article" + index)},[_c('c-link',{attrs:{"to":""}},[_c('en',{attrs:{"s":item.title}})],1)],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }